import React from 'react';

// Lenis removed for performance — native smooth scroll via CSS instead
export function SmoothScrollProvider({ children }) {
  return <>{children}</>;
}

export function useSmoothScroll() {
  return null;
}
